import { UiUtils } from "../common/uiUtils";

/**
 * A tool that moves the camera forward on press and hold.
 */
export class FirstPerson implements Autodesk.Viewing.ToolInterface {

    private viewer: Autodesk.Viewing.GuiViewer3D;
    private direction: any; 
    private dist: number;

    private contextMenu;
    private isTouching = false;
    private clock: THREE.Clock;
    private touchStartTime: number = 0;
    private isMoving = false;


    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.viewer = viewer;
    }

    register(): void { }

    deregister(): void { }

    activate(name: string, viewerApi?: Autodesk.Viewing.GuiViewer3D): void {
        console.log("FirstPerson activated");
        this.clock = new THREE.Clock();
        const viewer = this.viewer as any;
        this.contextMenu = viewer.contextMenu;
        if (this.isTouchEnabled()) {
            viewer.setContextMenu(null); //deactivate context menu
        }

        this.viewer.canvas.addEventListener("touchstart", this.touchStart);
        this.viewer.canvas.addEventListener("touchend", this.touchEnd);
        this.viewer.canvas.addEventListener("touchmove", this.touchMove);

        UiUtils.hideUiElementByClass("mobile-joystick");
    }

    touchStart = () => {
        this.isTouching = true;
        this.touchStartTime = this.clock.oldTime;
    }

    touchEnd = () => {
        this.isTouching = false;
        this.isMoving = false;
        this.touchStartTime = 0;
    }

    touchMove = () => {
        if (!this.isMoving) {
            this.touchStartTime = this.clock.oldTime;
        }
    }

    deactivate(name: string): void {
        console.log("FirstPerson deactivated");
        (this.viewer as any).setContextMenu(this.contextMenu); //reactivate context menu

        this.viewer.canvas.removeEventListener("touchstart", this.touchStart);
        this.viewer.canvas.removeEventListener("touchend", this.touchEnd);
        this.viewer.canvas.removeEventListener("touchmove", this.touchMove);
        this.clock.stop();
    }

    update(): boolean {
        const deltaTime = this.clock.getDelta();

        const deltaStart = this.clock.oldTime - this.touchStartTime;
        this.isMoving = this.isTouching && deltaStart > 1000;

        if (this.isMoving) {

            const speed = 4000; 
            const movement = speed * deltaTime;

            const target = this.viewer.navigation.getTarget();
          
            const position = this.viewer.navigation.getPosition();
            this.direction = new THREE.Vector3();
            this.direction.subVectors(position, target);

            this.direction.normalize();
            this.direction.multiplyScalar(-movement); 
            const newPos = position.add(this.direction);
         
            const newTarget = newPos.clone().add(this.direction);
            this.viewer.navigation.setView(newPos, newTarget);
            (this.viewer.navigation as any).orientCameraUp();

            return false;
        }

        return false;

    }

    getName(): string {
        return "SmartDrawings.FirstPerson";
    }

    getNames(): string[] {
        return [this.getName()];
    }

    private isTouchEnabled() {
        return ("ontouchstart" in window) ||
            (navigator.maxTouchPoints > 0);
    }
}